import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [20,[2],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-access": [22,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/activity": [23,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/banking-information": [24,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/tax-election": [25,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/type": [26,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/joint": [27,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/account": [28,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/beneficiary-inherited": [29,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/decedent-name": [30,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/individual": [31,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/select": [32,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiaries": [33,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-address": [34,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-details": [35,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-name": [36,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/trust-beneficiary": [37,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/type-of-beneficiary": [38,[2,4,7,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/estate-percentage-allocation": [39,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/secondary-owner": [40,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/investment-time-horizon": [41,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/risk-tolerance": [42,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/cryptocurrency-trading": [43,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/financial-information": [44,[2,4,7,8,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/instruments-knowledge": [45,[2,4,7,8,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/trading-objective": [46,[2,4,7,8,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-method": [47,[2,4,7,8],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/foreign-financial-institution": [48,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/legal-exemption": [49,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/select": [50,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-address": [51,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-details": [52,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-name": [53,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-tax-info": [54,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owners-table": [55,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/confirm-none": [56,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/individual": [57,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-entity": [58,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-individual": [59,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/basics": [60,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/company-secretary": [61,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/mailing-address": [62,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/primary-address": [63,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/same-mailing-address": [64,[2,4,7,11],[3]],
		"/(app)/(wizard)/(pre-submission)/business/relationship": [65,[2,4,7,11],[3]],
		"/(session)/confirmation": [118,[19]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload": [66,[2,4,7,12,13],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/address-opt-out": [67,[2,4,7,12,13],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/confirm": [68,[2,4,7,12,13],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/entity-upload": [69,[2,4,7,12,13],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/upload": [70,[2,4,7,12,13],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/important-documents": [71,[2,4,7,12],[3]],
		"/(app)/done/auto-approved": [113,[2,18],[3]],
		"/(app)/done/documents-required": [114,[2,18],[3]],
		"/(app)/done/joint-continuation": [115,[2,18],[3]],
		"/(app)/done/needs-review": [116,[2,18],[3]],
		"/(app)/(wizard)/(post-submission)/enablements/cryptocurrency-trading": [21,[2,4,5,6],[3]],
		"/(app)/error": [117,[2],[3]],
		"/(session)/joint-continuation-signup": [119,[19]],
		"/(session)/joint-continuation-signup/success": [120,[19]],
		"/(session)/login": [121,[19]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/industry": [72,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/political": [73,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/public-company": [74,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/select": [75,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/citizenship": [76,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/documents-to-prepare": [77,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/foreign-citizenship": [78,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/residency": [79,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/visa": [80,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/mailing-address": [81,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/name": [82,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/phone-number": [83,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/physical-address": [84,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/same-address": [85,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/sms-notifications": [86,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/employment-status": [87,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/job-details": [88,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/birth-date": [89,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/family": [90,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/subject-to-tax-withholding": [91,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/tax-number": [92,[2,4,7,14],[3]],
		"/(app)/(wizard)/(pre-submission)/security/confirm-identity": [93,[2,4,7,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/security-question": [94,[2,4,7,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/trusted-contact/add-trusted-contact": [95,[2,4,7,15,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/trusted-contact/address": [96,[2,4,7,15,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/trusted-contact/contact-info": [97,[2,4,7,15,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/trusted-contact/personal-info": [98,[2,4,7,15,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/authenticator": [99,[2,4,7,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/method-selection": [100,[2,4,7,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/setup": [101,[2,4,7,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/sms": [102,[2,4,7,15],[3]],
		"/(session)/signup": [122,[19]],
		"/(session)/signup/account-type": [123,[19]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/foreign-financial-institution": [103,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/select": [104,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor-details": [106,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor": [105,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/basics": [107,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/mailing-address-details": [108,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/primary-address": [109,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/same-mailing-address": [110,[2,4,7,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/review": [111,[2,4,7,17],[3]],
		"/(app)/[...catchAll]": [112,[2],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';